/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_OpenInputs */

const de__field_open = /** @type {(inputs: _Field_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offen`)
};

/**

* @param {_Field_OpenInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_open = /** @type {((inputs?: _Field_OpenInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_OpenInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_open(inputs)
});